import { combineEpics } from 'redux-observable';
import { authEpics } from './Auth/epics';
import { tableEpics } from './Table/epics';
import { customerEpics } from './Customer/epics';
import { routeEpics } from './Route/epics';

export const rootEpic = combineEpics(routeEpics, authEpics, tableEpics, customerEpics);
